import { translate } from "app/language/service"
import React from "react"
import { IUIConfiguration } from "../model"
import { setTempUiConfigUndoRedo } from "../tools/undo-redo"
import { UiConfigTranslation } from "./UiConfigTranslation"

interface IUiConfigTranslationsProps {
  uiConfig: IUIConfiguration
}

export const UiConfigTranslations = React.memo(({ uiConfig }: IUiConfigTranslationsProps) => (
  <UiConfigTranslation
    title={translate("admin.ui-configuration.translation.mennu-title")}
    translation={uiConfig.translations.menuTitle}
    setTranslation={newTranslation =>
      setTempUiConfigUndoRedo({ ...uiConfig, translations: { ...uiConfig.translations, menuTitle: newTranslation } })
    }
  />
))
